import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQSection = () => {
  const faqs = [{
    q: '¿Es legal hacer esto yo mismo?',
    a: 'Sí, es un derecho federal garantizado por la FCRA (Fair Credit Reporting Act).'
  }, {
    q: '¿Funciona si tengo ITIN?',
    a: 'Absolutamente, las leyes de protección al consumidor aplican para todos los residentes, independientemente de si usan SSN o ITIN.'
  }, {
    q: '¿Tengo que hablar con los bancos?',
    a: 'No, te enseñamos a que toda la comunicación sea por correo certificado para que quede evidencia legal irrefutable.'
  }, {
    q: '¿Cuánto subirá mi puntaje?',
    a: 'Depende de tu caso específico, pero eliminar una sola colección puede subir tu score entre 30 y 80 puntos de inmediato.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper bg="bg-navy-800" data-id="element-21">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-22">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-23">
        {faqs.map((faq, index) => <div key={index} className="bg-navy-900 rounded-xl border border-navy-800 overflow-hidden" data-id="element-24">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-25">
              <span className="font-bold text-lg md:text-xl text-white pr-8" data-id="element-26">
                {faq.q}
              </span>
              <ChevronDown className={`w-6 h-6 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-27" />
            </button>

            <AnimatePresence data-id="element-28">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-29">
                  <div className="p-6 pt-0 text-gray-300 text-lg border-t border-navy-800/50 mt-2" data-id="element-30">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
};